import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const orderHistoryPromise = import("./OrderHistory.js");
export default Auth(lazy(() => orderHistoryPromise));
